export enum CoverageStatus {
  ACTIVE = "Active",
  IN_PROGRESS = "In Progress",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  ERROR = "Error",
  COMPLETED = "Completed",
  INACTIVE = "Inactive",
  EV_TYPE_NOT_SUPPORTED = "EV Type Not Supported",
  UNKNOWN = "Unknown",
}
